export function shouldShowCustomizeFilterControls({
  customizingMode,
  pathname = '',
  isMediaLibraryModal = false,
}) {
  if (!customizingMode) return false;
  if (isMediaLibraryModal) return true;
  return !pathname.startsWith('/product/');
}
